// extracted by mini-css-extract-plugin
module.exports = {"billing":"Billing_billing__xpKmQ","label":"Billing_label__aXjXG","placeholder":"Billing_placeholder__aMJwl","loading":"Billing_loading__aCn0H"};